import Index from './Index';
import Header from './Header';
import SettingsContent from '../settings/Wrapper';
import { frontendURL } from '../../../helper/URLHelper';

export default [
  {
    path: frontendURL('accounts/:accountId/file-storage'),
    roles: ['administrator'],
    component: SettingsContent,
    props: {
      headerTitle: 'SIDEBAR.FILE_STORAGE',
      icon: 'ion-ios-folder',
      showNewButton: false,
      showDeleteButton: true,
      headerButtonText: 'FILE_STORAGE.DELETE.BUTTON',
    },
    children: [
      {
        path: '',
        name: 'file_storage_home',
        components: {
          default: Index,
          header: Header,
        },
        props: { descriptionKey: 'HELP_DESCRIPTION' },
        roles: ['administrator'],
      },
    ],
  },
];
